import { render, staticRenderFns } from "./VolunteerBackendPetsComponent.vue?vue&type=template&id=35ec3e12&"
import script from "./VolunteerBackendPetsComponent.vue?vue&type=script&lang=js&"
export * from "./VolunteerBackendPetsComponent.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerBackendPetsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports